import React, { useState } from 'react';
import { Segment, Icon, Table, Button } from 'semantic-ui-react';
import history from 'services/history';
import _ from 'lodash';
import { numFormat } from '@rededompedro/utils';

export default function DadosTurno(props) {
    const [dadosToSubmitTurno] = useState([]);
    const [dadosTurno] = useState([]);

    function getSomaValor(dado, tipo) {
        if (tipo === 1) {
            let aux = null;
            dado.map((x) => (aux += x.valor_bruto));
            return numFormat(parseFloat(aux));
        } else if (tipo === 2) {
            let aux = null;
            dado.map((x) => (aux += x.valor_desconto));
            return numFormat(parseFloat(aux));
        } else if (tipo === 3) {
            let aux = null;
            dado.map((x) => (aux += x.valor_liquido));
            return numFormat(parseFloat(aux));
        } else if (tipo === 4) {
            let aux = null;
            dado.map((x) => (aux += x.valor));
            return numFormat(parseFloat(aux));
        }
    }

    return (
        <div className="col d-flex align-items-center flex-column">
            <Segment basic textAlign="left" style={{ width: '100%', padding: '10px 0px' }}>
                <Button
                    style={{ width: '10%' }}
                    floated="left"
                    size="tiny"
                    icon
                    labelPosition="left"
                    onClick={() => history.goBack()}
                >
                    <Icon name="arrow left" />
                    Voltar
                </Button>
                {dadosToSubmitTurno.length > 0 && (
                    <Table
                        color="blue"
                        size="small"
                        definition
                        singleLine
                        className="mb-5"
                        compact="very"
                    >
                        <Table.Body>
                            <Table.Row textAlign="center">
                                <Table.HeaderCell style={{ padding: '20px' }} colSpan="2">
                                    Dados do Caixa
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Empresa
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%' }}>
                                    {dadosToSubmitTurno.restaurante}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Nº Controle
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%' }}>
                                    {dadosTurno[0].n_controle}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Nome do Caixa
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%' }}>
                                    {dadosTurno[0].nome_funcionario}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Data
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%' }}>
                                    {dadosToSubmitTurno.data_caixa}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Turno
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%' }}>
                                    {dadosToSubmitTurno.turno}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row textAlign="center">
                                <Table.HeaderCell style={{ padding: '20px' }} colSpan="2">
                                    Valores Entregues
                                </Table.HeaderCell>
                            </Table.Row>
                            {_.map(dadosTurno, ({ descricao, valor }, index) => (
                                <Table.Row key={index}>
                                    <Table.Cell style={{ width: '50%' }} textAlign="right">
                                        {descricao}
                                    </Table.Cell>
                                    <Table.Cell style={{ width: '50%' }}>
                                        {numFormat(valor)}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                            <Table.Row>
                                <Table.Cell style={{ width: '50%' }} textAlign="right">
                                    Total
                                </Table.Cell>
                                <Table.Cell style={{ width: '50%', fontWeight: 'bold' }}>
                                    {getSomaValor(dadosTurno, 4)}
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                )}
            </Segment>
        </div>
    );
}
